import { SchoolServiceResponse } from "../../school-service/models/school-service-response.model";
import { SchoolData } from "./school-data.model";

export class SchoolManagement{
  school: SchoolData;
  schoolServices: SchoolServiceResponse[];
  historicSchoolServices: SchoolServiceResponse[];
}

export class SchoolManagementDetails{
  schoolId: number;
  schoolName: string;
  centerCode: string;
  schoolNumber: number;
  batch: string;
  adpAcceptCenter: string;
  invoiceAccount: string;
  languageId: number;
  schoolAccountingAccount: string;
  zoneId: number;
  profitCenterCode: string;
  centerType: string;
  serviceType: string;
  customPayment: string;
  paymentTerms: string;
  paymentMethod: string;
  cauCode: string;
  cauName: string;
  isPrivate: boolean;
  invoicingMail: string;
  managerId: number;
  identification: string;
  address: string;
  city: string;
  zipCode: string;
  province: string;
  iseMonSchoolCode: string;
  showInReport: boolean;
  manager: string;
  schoolServices: SchoolServiceResponse[];
  historicSchoolServices: SchoolServiceResponse[];
}
export class SchoolManagementRequest{
  schoolId: number;
  schoolName: string;
  centerCode: string;
  schoolNumber: number;
  batch: string;
  adpAcceptCenter: string;
  invoiceAccount: string;
  languageId: number;
  schoolAccountingAccount: string;
  zoneId: number;
  profitCenterCode: string;
  centerType: string;
  serviceType: string;
  customPayment: string;
  paymentTerms: string;
  paymentMethod: string;
  cauCode: string;
  cauName: string;
  isPrivate: boolean;
  invoicingMail: string;
  managerId: number;
  identification: string;
  address: string;
  city: string;
  zipCode: string;
  province: string;
  iseMonSchoolCode: string;
  showInReport: boolean;
  manager: string;
  schoolServices: SchoolServiceResponse[];
}
